import { lazy } from 'react';

export const Home = lazy(() => import('./Home'));
export const HowItWorks = lazy(() => import('./HowItWorks'));
export const Stations = lazy(() => import('./Stations/Stations'));
export const Associations = lazy(() => import('./Associations/Associations'));
export const Prices = lazy(() => import('./Prices/Prices'));
export const WhoWeAre = lazy(() => import('./WhoWeAre/WhoWeAre'));
export const CommonQuestions = lazy(() => import('./CommonQuestions/CommonQuestions'));
export const ContactUs = lazy(() => import('./ContactUs'));
export const Profile = lazy(() => import('./Profile/Profile'));
export const Purchase = lazy(() => import('./Purchase'));
export const AssociationRegistration = lazy(() => import('./AssociationRegistration'));
export const StationRegistration = lazy(() => import('./StationRegistration'));
export const PageNotFound = lazy(() => import('./PageNotFound'));
export const Login = lazy(() => import('./Login/Login'));
export const Unsubscribe = lazy(() => import('./Unsubscribe'));
export const LeaveDetails = lazy(() => import('./LeaveDetails'));